module.exports = __webpack_public_path__ + "img/proxy-system.34be1623.webp";